export const environment = {
  production: true,
  isProduction: '#{isProduction}#',
  allowUnfinishedFeatures: '#{allowUnfinishedFeatures}#',
  apiUrl: '#{apiUrl}#',
  securityServiceApiEndPoint: '#{securityServiceApiEndPoint}#',
  reportServiceApiEndpoint: '#{reportServiceApiEndpoint}#',
  auditServiceApiEndPoint: '#{auditServiceApiEndpoint}#',
  vmsTimesheetServiceApiEndpoint: '#{vmsTimesheetServiceApiEndpoint}#',
  organizationServiceApiEndpoint: '#{organizationServiceApiEndpoint}#',
  peopleServiceApiEndpoint: '#{peopleServiceApiEndpoint}#',
  payrollServiceApiEndpoint: '#{payrollServiceApiEndpoint}#',
  onboardingServiceApiEndpoint: '#{onboardingServiceApiEndpoint}#',
  fboOnboardingServiceApiEndpoint: '#{fboOnboardingServiceApiEndpoint}#',
  ruleEngineApiEndpoint: '#{ruleEngineApiEndpoint}#',
  complianceServiceApiEndpoint: '#{complianceServiceApiEndpoint}#',
  generalServiceApiEndpoint: '#{generalServiceApiEndpoint}#',
  adminServiceApiEndpoint: '#{adminServiceApiEndpoint}#',
  workOrderServiceApiEndpoint: '#{workOrderServiceApiEndpoint}#',
  showComplianceComponent: '#{showComplianceComponent}#',
  rollbar: {
    accessToken: '#{Rollbar.FrontEndAccessToken}#',
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: '#{Rollbar.Environment}#'
    },
    enabled: '#{Rollbar.FrontEndEnabled}#'
  },
  gaTrackingId: '#{gaTrackingId}#',
  googleTagManagerId: '#{googleTagManagerId}#',
  fullStoryId: '#{fullStoryId}#',
  allowDuplicateSIN: '#{allowDuplicateSIN}#',
  pageLoader: {
    apiUrl: '#{pageLoader.apiUrl}#',
    allowLogging: '#{pageLoader.allowLogging}#'
  },
  azSearchAppInsightsInstrumentationKey: '#{azSearchAppInsightsInstrumentationKey}#',
  contractorPortalLoginUrl: '#{contractorPortalLoginUrl}#',
  isPortalMigrationFeatureEnable: '#{isPortalMigrationFeatureEnable}#',
  inviteFBOUserToContractorPortal: '#{InviteFBOUserToContractorPortal}#',
  sendInvitationReminderEnabled: '#{sendInvitationReminderEnabled}#',
  enabledOBRClientCompanyIds: '#{enabledOBRClientCompanyIds}#',
  instantRefreshChecklist: '#{instantRefreshChecklist}#',
  userPilotToken: '#{userPilotToken}#',
  enableQuickAddCanadianIncAddProfile: true,
  obpIntegrationServiceApiEndpoint: '#{obpIntegrationServiceApiEndpoint}#',
  sickPayReleaseAmountLimit: '#{sickPayReleaseAmountLimit}#',
  buildNumber: '#{buildNumber}#',
  googleMapsKey: '#{googleMapsKey}#',
  documentCollectorPageUrl: '#{documentCollectorPageUrl}#',
  devextremeKey: '#{devextremeKey}#',
  integrationConnectionServiceApiEndpoint: '#{integrationConnectionServiceApiEndpoint}#',
  msSso: {
    clientId: '#{msSso.clientId}#',
    authority: '#{msSso.authority}#',
    redirectUri: '#{ClientAppUrl}#/sso/redirect',
    postLogoutRedirectUri: '#{ClientAppUrl}#',
    scopes: {
      User: 'User.Read',
      WebApi: '#{msSso.scopes.WebApi}#',
    }
  },
  t4BurdenCalculator: {
    url: '#{t4BurdenCalculator.url}#',
    allowedOrigins: '#{t4BurdenCalculator.allowedOrigins}#'.split(',').map(origin => origin.trim())
  },
  mfeUrls: {
    paidTimeOff: '#{mfeUrls.paidTimeOff}#?type=approver',
    commissionDashboard: '#{mfeUrls.commissionDashboard}#',
    atsFieldMapping: '#{mfeUrls.atsFieldMapping}#',
    workflowHub: '#{mfeUrls.workflowHub}#',
    engagements: '#{mfeUrls.engagements}#'
  }
};
